
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/indoor-outdoor-gardening",
      function () {
        return require("private-next-pages/articles/indoor-outdoor-gardening.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/indoor-outdoor-gardening"])
      });
    }
  